import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import {
  ContainerCustomArea,
  ContarCaracteres,
  CustomTextarea,
  DropdownContainer,
  InstrucoesContainer,
  TituloDropdown,
} from "./style";
import { DropdownSelect } from "components/DropdownSelect";
import { useEffect, useState } from "react";
import { useProcessoFinanceiroAprovar } from "../../../../hooks/useProcessoFinanceiroAprovar";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: () => void;
  setMotivoCorrigir: (motivo: string | null) => void;
  motivoCorrigir: string | null;
}

export function ModalConfirmarCorrigirLotes({
  show,
  handleClose,
  onSubmit,
  setMotivoCorrigir,
  motivoCorrigir,
}: Props) {
  const { optionsMotivoCorrigirLote, buscarOptionsMotivoCorrigirLote } =
    useProcessoFinanceiroAprovar();
  const [showMotivoOutros, setShowMotivoOutros] = useState<boolean>(false);
  const [motivoOutros, setMotivoOutros] = useState<string>("");
  const limiteCaracteres = 1500;

  useEffect(() => {
    buscarOptionsMotivoCorrigirLote();
    setMotivoCorrigir(null);
  }, [show]);

  const onChangeMotivo = (motivo: string) => {
    if (motivo === "Outros") {
      setMotivoCorrigir(null);
      setShowMotivoOutros(true);
      return;
    }

    setShowMotivoOutros(false);
    setMotivoCorrigir(motivo);
  };

  const onChangeMotivoOutros = (motivo: string) => {
    const textoLimitado = motivo.slice(0, limiteCaracteres);

    setMotivoCorrigir(textoLimitado || null);
    setMotivoOutros(textoLimitado);
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Solicitar correção de lote"
      centered
      size="lg"
    >
      <InstrucoesContainer>
        Selecione abaixo o motivo para correção do lote.
      </InstrucoesContainer>
      <DropdownContainer>
        <TituloDropdown>Motivo</TituloDropdown>
        <DropdownSelect
          options={optionsMotivoCorrigirLote}
          selectedValue={showMotivoOutros ? "Outros" : motivoCorrigir}
          onSelect={onChangeMotivo}
          searchable
        />
        <ContainerCustomArea
          style={{ display: showMotivoOutros ? "block" : "none" }}
        >
          <TituloDropdown style={{ marginTop: 24 }}>
            Informe o motivo
          </TituloDropdown>
          <CustomTextarea
            value={motivoOutros}
            onChange={(e) => onChangeMotivoOutros(e.target.value)}
            placeholder="Informe o motivo da solicitação de correção do lote"
          />
          <ContarCaracteres className="d-flex justify-content-end gap-4">
            {(motivoCorrigir ?? "").length}/{limiteCaracteres}
          </ContarCaracteres>
        </ContainerCustomArea>
      </DropdownContainer>
      <div className="d-flex justify-content-end gap-4">
        <PrimaryButton
          style={{ width: "6rem" }}
          outline
          variante="primary"
          onClick={handleClose}
        >
          Cancelar
        </PrimaryButton>
        <PrimaryButton
          style={{ width: "6rem" }}
          onClick={onSubmit}
          disabled={!motivoCorrigir}
        >
          Salvar
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
